import { render, staticRenderFns } from "./IntervalDetails.vue?vue&type=template&id=7ecb80fe"
import script from "./IntervalDetails.vue?vue&type=script&lang=js"
export * from "./IntervalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports